import React from 'react';
import {connect} from "react-redux";

import QuestionPoint from "./QuestionPoint";
import PropTypes from "prop-types";

const coordinates = [
    {x: 151, y: 85 },
    {x: 135, y: 152 },
    {x: 109, y: 111 },
    {x: 127, y: 37 },
    {x: 87, y: 153 },
    {x: 135, y: 200 },
    {x: 13, y: 107 },
    {x: 62, y: 110 },
    {x: 41, y: 68 },
    {x: 81, y: 201 },
    {x: 175, y: 44 },
    {x: 175, y: 127 },
    {x: 178, y: 176 },
    {x: 900, y: 85 },
    {x: 90, y: 65 }
];

const Environment = (props) => {
    return (
        <svg viewBox="0 0 260 260">
            <g className="environment">
                <g className="points">
                    <circle fill="#FFFFFF" cx="47.6" cy="37.2" r="1.2"/>
                    <circle fill="#FFFFFF" cx="38.1" cy="46" r="1.2"/>
                    <circle fill="#FFFFFF" cx="29.5" cy="55.8" r="1.2"/>
                    <circle fill="#FFFFFF" cx="22" cy="66.4" r="1.2"/>
                    <circle fill="#FFFFFF" cx="15.7" cy="77.7" r="1.2"/>
                    <circle fill="#FFFFFF" cx="10.6" cy="89.6" r="1.2"/>
                    <circle fill="#FFFFFF" cx="6.8" cy="102" r="1.2"/>
                    <circle fill="#FFFFFF" cx="4.2" cy="114.7" r="1.2"/>
                    <circle fill="#FFFFFF" cx="3.1" cy="127.6" r="1.2"/>
                    <circle fill="#FFFFFF" cx="3.2" cy="140.6" r="1.2"/>
                    <circle fill="#FFFFFF" cx="4.8" cy="153.4" r="1.2"/>
                    <circle fill="#FFFFFF" cx="7.6" cy="166.1" r="1.2"/>
                    <circle fill="#FFFFFF" cx="11.8" cy="178.3" r="1.2"/>
                    <circle fill="#FFFFFF" cx="17.2" cy="190.1" r="1.2"/>
                    <circle fill="#FFFFFF" cx="23.9" cy="201.2" r="1.2"/>
                    <circle fill="#FFFFFF" cx="31.6" cy="211.6" r="1.2"/>
                    <circle fill="#FFFFFF" cx="40.4" cy="221.1" r="1.2"/>
                    <circle fill="#FFFFFF" cx="50.2" cy="229.7" r="1.2"/>
                    <circle fill="#FFFFFF" cx="60.8" cy="237.2" r="1.2"/>
                    <circle fill="#FFFFFF" cx="72.1" cy="243.5" r="1.2"/>
                    <circle fill="#FFFFFF" cx="84" cy="248.6" r="1.2"/>
                    <circle fill="#FFFFFF" cx="96.4" cy="252.4" r="1.2"/>
                    <circle fill="#FFFFFF" cx="109.1" cy="255" r="1.2"/>
                    <circle fill="#FFFFFF" cx="122" cy="256.2" r="1.2"/>
                    <circle fill="#FFFFFF" cx="135" cy="256" r="1.2"/>
                    <circle fill="#FFFFFF" cx="147.9" cy="254.4" r="1.2"/>
                    <circle fill="#FFFFFF" cx="160.5" cy="251.6" r="1.2"/>
                    <circle fill="#FFFFFF" cx="172.8" cy="247.4" r="1.2"/>
                    <circle fill="#FFFFFF" cx="184.5" cy="242" r="1.2"/>
                    <circle fill="#FFFFFF" cx="195.7" cy="235.3" r="1.2"/>
                    <circle fill="#FFFFFF" cx="206.1" cy="227.6" r="1.2"/>
                    <circle fill="#FFFFFF" cx="215.6" cy="218.8" r="1.2"/>
                    <circle fill="#FFFFFF" cx="224.1" cy="209" r="1.2"/>
                    <circle fill="#FFFFFF" cx="231.6" cy="198.4" r="1.2"/>
                    <circle fill="#FFFFFF" cx="237.9" cy="187.1" r="1.2"/>
                    <circle fill="#FFFFFF" cx="243" cy="175.2" r="1.2"/>
                    <circle fill="#FFFFFF" cx="246.9" cy="162.8" r="1.2"/>
                    <circle fill="#FFFFFF" cx="249.4" cy="150.1" r="1.2"/>
                    <circle fill="#FFFFFF" cx="250.6" cy="137.2" r="1.2"/>
                    <circle fill="#FFFFFF" cx="250.4" cy="124.2" r="1.2"/>
                    <circle fill="#FFFFFF" cx="248.9" cy="111.4" r="1.2"/>
                    <circle fill="#FFFFFF" cx="246" cy="98.7" r="1.2"/>
                    <circle fill="#FFFFFF" cx="241.8" cy="86.4" r="1.2"/>
                    <circle fill="#FFFFFF" cx="236.4" cy="74.7" r="1.2"/>
                    <circle fill="#FFFFFF" cx="229.8" cy="63.5" r="1.2"/>
                    <circle fill="#FFFFFF" cx="222" cy="53.2" r="1.2"/>
                    <circle fill="#FFFFFF" cx="213.2" cy="43.6" r="1.2"/>
                    <circle fill="#FFFFFF" cx="203.5" cy="35.1" r="1.2"/>
                    <circle fill="#FFFFFF" cx="192.9" cy="27.6" r="1.2"/>
                    <circle fill="#FFFFFF" cx="181.6" cy="21.3" r="1.2"/>
                    <circle fill="#FFFFFF" cx="69.1" cy="22.8" r="1.2"/>
                    <circle fill="#FFFFFF" cx="58" cy="29.4" r="1.2"/>
                    <path fill="#FFFFFF" d="M78.8,16l2.1-0.8l0.2,0.5c0.1,0.3,0.2,0.5,0.4,0.7c0.2,0.2,0.5,0.2,0.7,0.1c0.4-0.2,0.6-0.6,0.4-1.2
                    l-1.5-4.1L78.8,12l-0.7-1.8l4.4-1.7l2.2,5.9c0.7,1.9-0.4,3.3-1.8,3.9c-1.4,0.5-3.2,0.2-3.9-1.7L78.8,16z"/>
                    <path fill="#FFFFFF" d="M89.3,11.7L89.3,11.7l0.1-0.1c-0.2-0.5-0.6-0.6-1.1-0.4c-0.8,0.2-1.5,1.1-1.5,1.1L85.5,11
                    c0.6-0.8,1.4-1.3,2.4-1.6c1.8-0.6,3.1,0.1,3.6,1.7l1.2,3.9l-1.9,0.6l-0.1-0.4c0-0.1-0.1-0.3-0.1-0.4h0c0,0-0.2,1.1-1.5,1.5
                    c-1.2,0.4-2.4-0.1-2.8-1.4C85.7,13,88.3,12,89.3,11.7z M89.1,14.4c0.5-0.2,0.8-0.9,0.7-1.4l0-0.1l-0.2,0.1
                    c-0.7,0.2-1.4,0.6-1.2,1.2C88.5,14.4,88.7,14.5,89.1,14.4L89.1,14.4z"/>
                    <path fill="#FFFFFF"
                          d="M95.4,4.8l2.1-0.5l0.4,1.7l-2.1,0.5L95.4,4.8z M96,7.2l2.1-0.5l1.5,6.4l-2.1,0.5L96,7.2z"/>
                    <path fill="#FFFFFF" d="M104.6,9.8c0,0,0.8,0.5,1.8,0.4c0.3-0.1,0.6-0.2,0.6-0.4c-0.1-0.6-3.1-0.1-3.5-2.2
                    c-0.2-1.2,0.8-2.2,2.3-2.4s2.4,0.4,2.4,0.4l-0.5,1.7c-0.5-0.3-1.1-0.4-1.6-0.3c-0.3,0.1-0.6,0.2-0.6,0.4c0.1,0.5,3.1,0.1,3.5,2.2
                    c0.2,1.1-0.6,2.2-2.3,2.5c-1,0.2-1.9,0-2.8-0.5L104.6,9.8z M105.3,2.7l2.2-0.4l-1.2,2.1l-1.7,0.3L105.3,2.7z"/>
                    <path fill="#FFFFFF" d="M109.8,4.6l2.1-0.2l0.1,1.1c0,0.1,0,0.3,0,0.4h0C112.3,5,113,4.1,114,4c0.1,0,0.2,0,0.3,0l0.3,2.2
                    c-0.1,0-0.3,0-0.4,0c-0.5,0.1-1.3,0.3-1.6,1.3c0,0.3-0.1,0.6,0,0.9l0.3,2.5l-2.2,0.3L109.8,4.6z"/>
                    <path fill="#FFFFFF" d="M118.9,3.6c2.1-0.1,3.8,1.2,3.9,3.2c0.1,2.1-1.4,3.5-3.5,3.6s-3.8-1.1-3.9-3.2
                    C115.3,5.2,116.9,3.7,118.9,3.6z M119.2,8.6c0.8,0,1.5-0.7,1.4-1.7s-0.8-1.6-1.6-1.5c-0.8,0-1.5,0.7-1.4,1.7
                    C117.7,8.2,118.4,8.7,119.2,8.6L119.2,8.6z"/>
                    <path fill="#FFFFFF" d="M126.8,3.4c1.3,0,1.7,0.5,1.7,0.5h0c0,0,0-0.1,0-0.3l0-2.6l2.2,0l-0.1,9.1l-2.1,0V9.7c0-0.2,0-0.4,0-0.4h0
                    c0,0-0.6,1-1.9,0.9c-1.8,0-3-1.4-2.9-3.5C123.8,4.7,125.1,3.4,126.8,3.4z M127.3,8.4c0.7,0,1.3-0.5,1.3-1.6c0-0.8-0.4-1.6-1.3-1.6
                    c-0.7,0-1.3,0.6-1.3,1.6C126,7.8,126.6,8.4,127.3,8.4L127.3,8.4z"/>
                    <path fill="#FFFFFF" d="M136.1,3.7c2.1,0.2,3.6,1.7,3.5,3.7s-1.9,3.3-4,3.1c-2.1-0.1-3.6-1.6-3.5-3.7S134.1,3.6,136.1,3.7z
                     M135.8,8.7c0.8,0.1,1.5-0.5,1.6-1.5s-0.6-1.7-1.4-1.7s-1.5,0.5-1.6,1.5C134.3,8,134.9,8.7,135.8,8.7L135.8,8.7z"/>
                    <path fill="#FFFFFF" d="M140.6,4.2l2.3,0.3l0.2,4c0,0.2,0,0.5,0,0.7h0c0.1-0.2,0.1-0.4,0.2-0.7l1.5-3.7l1.9,0.3l0.3,4
                    c0,0.2,0,0.5,0,0.7h0c0-0.2,0.1-0.5,0.2-0.7l1.4-3.7l2.3,0.3l-2.8,6.2l-2.4-0.4l-0.3-3.1c0-0.2,0-0.5,0-0.7h0
                    c-0.1,0.2-0.1,0.5-0.2,0.7l-1.2,2.9l-2.5-0.4L140.6,4.2z"/>
                    <path fill="#FFFFFF"
                          d="M152.1,6l2.2,0.5l-1.3,6.4l-2.2-0.5L152.1,6z M152.7,3.5l2.1,0.4l-0.4,1.7l-2.1-0.4L152.7,3.5z"/>
                    <path fill="#FFFFFF" d="M155.5,11.1c0,0,0.5,0.8,1.5,1.1c0.3,0.1,0.7,0.1,0.7-0.1c0.1-0.6-2.8-1.4-2.3-3.4
                    c0.3-1.2,1.6-1.7,3.1-1.3c1.5,0.4,2.1,1.3,2.1,1.3l-1.1,1.3c-0.4-0.4-0.8-0.8-1.4-0.9c-0.3-0.1-0.7-0.1-0.7,0.2
                    c-0.1,0.5,2.8,1.3,2.3,3.4c-0.3,1.1-1.5,1.8-3.1,1.4c-0.9-0.2-1.8-0.8-2.3-1.6L155.5,11.1z"/>
                    <path fill="#FFFFFF" d="M163.1,6.1l2.1,0.7l-1.4,4.5l0.6,0.2l1.9-1.7l2.3,0.7l-2.7,2.3l0,0l1,4.1l-2.4-0.8l-0.6-2.8l-0.7-0.2
                    l-0.8,2.4l-2.1-0.7L163.1,6.1z"/>
                    <path fill="#FFFFFF" d="M172.9,11.9c1.9,0.7,3,2.6,2.3,4.6c-0.7,1.9-2.8,2.6-4.7,1.9c-1.9-0.7-3-2.6-2.3-4.5
                    S170.9,11.1,172.9,11.9z M171.1,16.6c0.8,0.3,1.6,0,2-0.9c0.4-0.9-0.1-1.8-0.8-2s-1.6,0-2,1C169.9,15.5,170.3,16.3,171.1,16.6z"/>
                </g>
                { props.survey.map((question, index) => {
                    return <QuestionPoint key={question.id} code={question.code} area="environment" percent={question.answers[0].percent}
                                          x={coordinates[index].x} y={coordinates[index].y}/>
                }) }
            </g>
        </svg>
    );
};

const mapStateToProps = (state) => {
    return {
        survey: state.survey.environment.questions,
    }
};

export default connect(mapStateToProps)(Environment);


Environment.defaultProps = {
    click: () => {
    },
};

Environment.propTypes = {
    click: PropTypes.func,

};



// WEBPACK FOOTER //
// ./sources/js/components/Summary/graph/Environment.js